module.exports = __webpack_public_path__ + "files/e91adf2288ce6b90e434260fcf26642b.png";